import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { PATHS } from '@/common';
import { useOrphanModeStore } from '@/modules/core/store';

import { formatOrganizationViewData } from './formatData';
import { OrganizationViewPayload } from './payloadTypes';

export const ORGANIZATION_VIEW_DATA_QUERY_KEY = 'ORGANIZATION_VIEW_DATA_QUERY_KEY';

const useOrganizationViewDataQuery = (organizationId?: string, enabled: boolean = true) => {
  const { linkedEmployee } = useOrphanModeStore();
  const currentOrganizationId = linkedEmployee?.organizationId || organizationId;
  const { data, isLoading, refetch, isSuccess, isError } = useQuery(
    // TODO: find proper type
    [ORGANIZATION_VIEW_DATA_QUERY_KEY, PATHS.ORGANIZATION_INFO(currentOrganizationId), enabled],
    () => api.get<OrganizationViewPayload>(PATHS.ORGANIZATION_INFO(currentOrganizationId)),
    {
      enabled: Boolean(!!currentOrganizationId && enabled),
    }
  );

  const formattedData = useMemo(() => formatOrganizationViewData(data?.data), [data]);

  return {
    formattedData,
    isLoading,
    refetch,
    isSuccess,
    isError,
  };
};

export default useOrganizationViewDataQuery;
